import { getCurrentUser } from "@/plugins/firebase"
import Vue from "vue"
import VueRouter, { RouteConfig } from "vue-router"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("@/views/Forgot.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import("@/views/Projects.vue")
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/Contact.vue")
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("@/views/Admin.vue"),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "create",
        name: "Create",
        component: () => import("@/views/Create.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "upload",
        name: "Upload",
        component: () => import("@/views/Upload.vue"),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "*",
    component: () => import("@/views/Error.vue")
  }
]

const router = new VueRouter({
  routes,
  mode: "history"
})

router.beforeEach(async (to, _from, next) => {
  const requiresAuth = to.meta.requiresAuth
  const user = await getCurrentUser()
  if (requiresAuth && !user) {
    next("/login")
  } else if (requiresAuth === false && user) {
    next("/")
  } else {
    next()
  }
})

export default router
